import { isHeroBrandEnabled } from '../utils/heroBrandUtils';
import { getBusinessTypeTag } from '../utils/businessType';

export const COL = {
  // Interpretation orders / Past interpretations
  TIME: 'date',
  ORDER_NUMBER: 'orderNumber',
  EXTERNAL_ORDER_ID: 'externalOrderId',
  USER_GROUP: 'invoiceUserGroup',
  LANGUAGE: 'language',
  STATUS: 'status',
  CALL_TYPE: 'callType',
  INTERPRETER_PHONE: 'hotlinePhoneNumber',
  INTERPRETER_NAME: 'interpreterName',
  DURATION: 'durationEstimated',
  REPORTED_DURATION: 'durationActual',
  CUSTOMER: 'customerName',
  COST_CENTER: 'invoiceRef',
  ALT_COST_CENTER: 'invoiceRecipientRef',
  DEVIATION: 'deviation',
  DEVIATION_RESOLUTION: 'deviationResolution',
  FIRST: 'firstColumn',
  ACTION_MENU: 'actionMenu',
  EDIT: 'editButton',
  PREVIEW: 'previewButton',
  SELECTION: 'selection',

  // Translations
  TR_ORDER_NUMBER: 'orderNumber',
  TR_ORDER_DATE: 'orderDate',
  TR_DELIVERY_DATE: 'delivery',
  TR_USER_GROUP: 'userGroup',
  TR_FROM: 'fromLanguage',
  TR_TO: 'toLanguage',
  TR_TRANSLATOR: 'username',
  TR_CUSTOMER: 'customer',
  TR_STATUS: 'status',
};

export const TABLES = {
  BOOKINGS: 'bookings',
  BILLING: 'billing',
  TRANSLATIONS: 'translations',
};

const DEFAULT_MARKET = 'default';
const HEROTOLK_MARKET = 'herotolk';

/**
 * Ordered column lists per market.
 */
const LAYOUTS = {
  [DEFAULT_MARKET]: {
    [TABLES.BOOKINGS]: [
      COL.TIME,
      COL.LANGUAGE,
      COL.STATUS,
      COL.DURATION,
      COL.CALL_TYPE,
      COL.INTERPRETER_PHONE,
      COL.USER_GROUP,
      COL.CUSTOMER,
      COL.COST_CENTER,
      COL.ALT_COST_CENTER,
      COL.ORDER_NUMBER,
      COL.EXTERNAL_ORDER_ID,
      COL.ACTION_MENU,
    ],
    [TABLES.BILLING]: [
      COL.FIRST,
      COL.TIME,
      COL.LANGUAGE,
      COL.STATUS,
      COL.DURATION,
      COL.CALL_TYPE,
      COL.INTERPRETER_PHONE,
      COL.CUSTOMER,
      COL.ORDER_NUMBER,
      COL.EXTERNAL_ORDER_ID,
      COL.USER_GROUP,
      COL.COST_CENTER,
      COL.ALT_COST_CENTER,
      COL.EDIT,
      COL.PREVIEW,
      COL.SELECTION,
    ],
  },

  [HEROTOLK_MARKET]: {
    [TABLES.BOOKINGS]: [
      COL.TIME,
      COL.ORDER_NUMBER,
      COL.EXTERNAL_ORDER_ID,
      COL.USER_GROUP,
      COL.LANGUAGE,
      COL.STATUS,
      COL.CALL_TYPE,
      COL.INTERPRETER_PHONE,
      COL.DURATION,
      COL.CUSTOMER,
      COL.COST_CENTER,
      COL.ACTION_MENU,
    ],
    [TABLES.BILLING]: [
      COL.FIRST,
      COL.TIME,
      COL.ORDER_NUMBER,
      COL.EXTERNAL_ORDER_ID,
      COL.USER_GROUP,
      COL.LANGUAGE,
      COL.CALL_TYPE,
      COL.INTERPRETER_PHONE,
      COL.INTERPRETER_NAME,
      COL.DURATION,
      COL.REPORTED_DURATION,
      COL.CUSTOMER,
      COL.COST_CENTER,
      COL.DEVIATION,
      COL.DEVIATION_RESOLUTION,
      COL.EDIT,
    ],
  },
};

const TRANSLATIONS_LAYOUT = [
  COL.TR_ORDER_NUMBER,
  COL.TR_ORDER_DATE,
  COL.TR_DELIVERY_DATE,
  COL.TR_USER_GROUP,
  COL.TR_FROM,
  COL.TR_TO,
  COL.TR_TRANSLATOR,
  COL.TR_CUSTOMER
];

const MARKET_OVERRIDES = {};

const COLUMN_HEADERS = {
  [HEROTOLK_MARKET]: {
    [COL.EDIT]: '',
  },
};

const getMarket = () => (isHeroBrandEnabled() ? HEROTOLK_MARKET : DEFAULT_MARKET);

export const getColumnLayout = (table) => {
  if (table === TABLES.TRANSLATIONS) {
    return TRANSLATIONS_LAYOUT;
  }

  const override = MARKET_OVERRIDES[getBusinessTypeTag()];
  if (override && override[table]) {
    return override[table];
  }

  return LAYOUTS[getMarket()][table];
};

export const resolveColumns = (table, definitions) => {
  const headers = COLUMN_HEADERS[getMarket()] || {};

  return getColumnLayout(table)
    .map((id) => {
      const column = definitions[id];
      if (!column) {
        return null;
      }
      return Object.prototype.hasOwnProperty.call(headers, id)
        ? { ...column, Header: headers[id] }
        : column;
    })
    .filter(Boolean);
};

export const __LAYOUTS = LAYOUTS;
export const __TRANSLATIONS_LAYOUT = TRANSLATIONS_LAYOUT;
